import { gql } from "@apollo/client";

import { CERTIFICATE_FIELDS } from "../queries/certificates";

export const CREATE_CERTIFICATE = gql`
  mutation CreateCertificate($input: UpdateCertificateInput!) {
    createCertCertificate(input: $input) {
      ...CertificateFields
    }
  }
  ${CERTIFICATE_FIELDS}
`;

export const UPDATE_CERTIFICATE = gql`
  mutation UpdateCertificate($id: ID!, $input: UpdateCertificateInput!) {
    updateCertCertificate(id: $id, input: $input) {
      ...CertificateFields
    }
  }
  ${CERTIFICATE_FIELDS}
`;

export const DELETE_CERTIFICATE = gql`
  mutation DeleteCertificate($id: ID!) {
    deleteCertCertificate(id: $id) {
      id
    }
  }
`;
